import React from 'react';
import EditNoteIcon from '@mui/icons-material/EditNote';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { ArcIconButton, ArcStack, ArcText, ArcTooltip } from '@src/core/ui';
import { useSelectedFleetDrone } from '@src/features/fleet/pages/drones-page/hooks';
import { DroneRegisterForm } from '@src/features/fleet/components';
import { useDisclosure } from '@src/core/hooks';
import { useConfirm } from '@src/core/controllers';
import { toast } from 'react-toastify';
import { useDeleteDroneMutation } from '@src/features/fleet/redux/api';
import { trackError, toTrackedError } from '@src/core/sentry';
import { useFleetLimitedAccess } from '@src/features/fleet/context/fleet-limited-access-context';
import { useGetUserDataQuery } from '@src/core/features';

const DroneHeader: React.FC = () => {
  const fleetLimited = useFleetLimitedAccess();
  const { confirm } = useConfirm();
  const { open, show, hide } = useDisclosure();
  const { selectedDrone, droneId } = useSelectedFleetDrone();
  const { data: profile } = useGetUserDataQuery();

  const canDeleteDrone = !profile?.roleStatus?.isOperator;

  const [ deleteDrone, { isLoading } ] = useDeleteDroneMutation();

  const onDeleteDrone = async () => {
    if (!droneId) return;

    if (await confirm()) {
      deleteDrone(droneId).unwrap().then(() => {
        toast.success('Delete Drone SuccessText');
      }).catch((err: unknown) => {
        trackError(toTrackedError(err), { code: 'FE_0021', extra: { flow: 'deleteDrone' } });
      });
    }
  };

  return (
    <React.Fragment>
      {!fleetLimited && (
        <DroneRegisterForm
          open={open}
          onClose={hide}
          title='Edit Drone'
          drone={selectedDrone}
        />
      )}
      <ArcStack spacing={1} direction='row' alignItems='center' justifyContent='space-between'>
        <ArcStack spacing={1} direction='row' alignItems='center'>
          <ArcText.h3 fontWeight={500}> {selectedDrone?.name} </ArcText.h3>
          <ArcText.h5 fontWeight={500} color='text.secondary'> {selectedDrone?.serialNumber} </ArcText.h5>
        </ArcStack>

        {!fleetLimited && (
          <ArcStack spacing={2} direction='row' alignItems='center'>
            <ArcTooltip title='Edit Drone'>
              <ArcIconButton onClick={show}>
                <EditNoteIcon />
              </ArcIconButton>
            </ArcTooltip>
            {canDeleteDrone && (
              <ArcTooltip title='Delete Drone'>
                <ArcIconButton isLoading={isLoading} onClick={onDeleteDrone}>
                  <DeleteOutlineIcon color='error' />
                </ArcIconButton>
              </ArcTooltip>
            )}
          </ArcStack>
        )}
      </ArcStack>
    </React.Fragment>
  );
};

export default DroneHeader;
